import { render, staticRenderFns } from "./SLink.vue?vue&type=template&id=d11553be&scoped=true"
import script from "./SLink.vue?vue&type=script&lang=js"
export * from "./SLink.vue?vue&type=script&lang=js"
import style0 from "./SLink.vue?vue&type=style&index=0&id=d11553be&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d11553be",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yanchenrong/code/youxiang/muying/muying-admin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d11553be')) {
      api.createRecord('d11553be', component.options)
    } else {
      api.reload('d11553be', component.options)
    }
    module.hot.accept("./SLink.vue?vue&type=template&id=d11553be&scoped=true", function () {
      api.rerender('d11553be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/page/modules/editor/modules/SLink.vue"
export default component.exports